export default import.meta.ROLLDOWN_FILE_URL_m8ZVJMa9R0xp1E9MHm5YNg